import { storage } from "../lib/storage";
import { sharedDailySource } from "../lib/rounds";
import { migrateStorageKey } from "./roundLoop";
import { createTrendLoop, resolveTrend, type TrendReveal } from "./trendLoop";
import { useSettingsStore } from "./settingsStore";

/**
 * The Predict daily trend Loop (spec §11): guess the direction over the daily
 * bank, resolved Higher/Lower against the difficulty preset from settings.
 * The lifecycle comes from createRoundLoop and the trend adapter from
 * trendLoop.ts (shared with the weekly and monthly trend Loops, ADR-0013);
 * this file supplies the daily bank and the Loop's persistence keys.
 */

const SCORE_KEY = "predict-daily:score";
const STREAK_KEY = "predict-daily:streak";

// Pre-rename keys (GRA-96 vocabulary sweep, finished at the storage tier).
migrateStorageKey(storage, "simple:score", SCORE_KEY);
migrateStorageKey(storage, "simple:streak", STREAK_KEY);

/** What the daily Loop reveals: the resolution it was scored against. */
export type PredictDailyReveal = TrendReveal;

/** Resolve a daily commitment against the active difficulty preset. */
export const resolvePredictDaily = resolveTrend;

export const usePredictDailyStore = createTrendLoop({
  timeframe: "daily",
  openSource: sharedDailySource,
  seenKey: "seen:daily",
  scoreKey: SCORE_KEY,
  streakKey: STREAK_KEY,
});

// The barrier filter (GRA-140) is preset-specific: a Round that hit a barrier
// on the old preset can only time-cap on the new one. Re-check the on-screen
// Round whenever the preset changes, so a mid-Round difficulty switch never
// leaves a Round on screen that would resolve by the time cap.
useSettingsStore.subscribe((state, prevState) => {
  if (state.preset !== prevState.preset) usePredictDailyStore.getState().revalidate();
});
